(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["preorder-login-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      var modal = document.querySelector('[data-preorder-login-modal]');
      if (!modal) return;

      var triggers = document.querySelectorAll('[data-preorder-login-trigger]');
      var lastFocus = null;

      function onKeydown(event) {
        if (event.key === 'Escape') close();
      }

      function open() {
        lastFocus = document.activeElement;
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('preorder-login-open');
        var focusable = modal.querySelector('button, a, shopify-account, [tabindex]');
        if (focusable && focusable.focus) focusable.focus();
        document.addEventListener('keydown', onKeydown);
      }

      function close() {
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('preorder-login-open');
        document.removeEventListener('keydown', onKeydown);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          open();
        });
      });

      modal.querySelectorAll('[data-preorder-login-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
